import { connect } from "react-redux";
import StreamFilterPropertyTypeOverlay from "../StreamFilterPropertyTypeOverlay";

function select({ mls, stream }) {
  const { prop_type, prop_sub_type } = stream.filters.byId;
  const propertyTypes = (mls.standardFields.byId.prop_type
    ? mls.standardFields.byId.prop_type.values
    : []
  ).map((type) => ({ label: type, value: type }));
  const selectedPropertyTypes = (prop_type || {}).eq || null;
  const hasSelectedPropertyTypes = !!(selectedPropertyTypes || []).length;
  const propertySubTypes = (mls.standardFields.byId.prop_sub_type
    ? mls.standardFields.byId.prop_sub_type.values
    : []
  ).map((type) => ({ label: type, value: type }));
  const hasPropertySubTypes = !!propertySubTypes.length;
  const selectedPropertySubTypes = (prop_sub_type || {}).eq || null;
  const hasSelectedPropertySubTypes = !!(selectedPropertySubTypes || []).length;

  return {
    propertyTypes,
    hasPropertySubTypes,
    selectedPropertyTypes,
    hasSelectedPropertyTypes,
    propertySubTypes,
    selectedPropertySubTypes,
    hasSelectedPropertySubTypes
  };
}

export default connect(select)(StreamFilterPropertyTypeOverlay);
